import React from 'react';
import './BrandsCarousel.css';

const BrandsCarousel = () => {
  const brands = [
    { name: 'Schiesser', color: '#FF6B6B', fontStyle: 'elegant' },
    { name: 'Liegelind', color: '#4ECDC4', fontStyle: 'playful' },
    { name: 'Kanz', color: '#FFD93D', fontStyle: 'bold' },
    { name: 'Zewi', color: '#95E1D3', fontStyle: 'modern' },
    { name: 'bébé-jou', color: '#F38181', fontStyle: 'elegant' },
    { name: 'Wisa Gloria', color: '#AA96DA', fontStyle: 'vintage' },
  ];

  return (
    <section className="brands-section">
      <div className="brands-container">
        <div className="section-header">
          <span className="section-badge brands-badge">Unsere Premium Marken</span>
          <h2 className="section-title">
            Qualität, der Sie <span className="highlight-text-brands">vertrauen</span> können
          </h2>
          <p className="section-description">
            Seit 1977 bieten wir ausgewählte Kindermode von renommierten Herstellern.
            <br />
            Diese Marken begleiten euch nun zum letzten Mal in unserem Ausverkauf.
          </p>
        </div>

        <div className="carousel-wrapper">
          <div className="carousel-track">
            {[...brands, ...brands, ...brands].map((brand, index) => (
              <div
                key={index}
                className={`brand-card ${brand.fontStyle}`}
                style={{ '--brand-color': brand.color }}
              >
                <div className="brand-content">
                  <h3 className="brand-name">{brand.name}</h3>
                  <div className="brand-underline"></div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="brands-note">
          <p>
            <strong>Hinweis:</strong> Alle Markenartikel sind nur noch solange der Vorrat reicht.
            Kommen Sie früh vorbei und sichern Sie sich Ihre Favoriten!
          </p>
        </div>
      </div>
    </section>
  );
};

export default BrandsCarousel;